var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgEmail = function SvgEmail(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M2.3 6.333c0-1.098.865-2.033 1.986-2.033h15.428c1.12 0 1.986.935 1.986 2.033v11.334c0 1.098-.866 2.033-1.986 2.033H4.286c-1.12 0-1.986-.934-1.986-2.033V6.333ZM4.286 5.7c-.3 0-.586.26-.586.633v1.268L12 12.52 20.3 7.6V6.333c0-.374-.286-.633-.586-.633H4.286ZM20.3 9.23 12 14.147 3.7 9.23v8.438c0 .374.286.633.586.633h15.428c.3 0 .586-.26.586-.633V9.229Z"
  })));
};
export { SvgEmail as ReactComponent };
export default __webpack_public_path__ + "3d948951ae1e0b46e6c4db7aa8e7666a.svg";